import template from './template.html'

angular.module('contabilidad.polizas')
  .component('contabilidadPolizasFacturacionListaEmpresa', {
    controller: ContabilidadPolizasFacturacionListaEmpresaComponent,
    template,
    bindings: {
      empresa: '<',
      clientes: '<',
    },
  })

function ContabilidadPolizasFacturacionListaEmpresaComponent ($filter) {
  var $ctrl = this
  $ctrl.$onChanges = $onChanges

  $ctrl.empresa = undefined
  $ctrl.clientes = undefined
  $ctrl.data = {}

  $ctrl.groupBy = $filter('groupBy')

  function $onChanges (changes) {
    if (changes.clientes) {
      $ctrl.data = $ctrl.groupBy($ctrl.clientes, 'receptor.nombre')
    }
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/facturacion/lista/empresa/component.js